import { Link } from "@tanstack/react-router";
import { dashIfEmpty } from "../../lib/format";

/**
 * An order's reference, linked to wherever it is packed. A Loot OS withdrawal (`WITHDRAW_ASSET`)
 * is packed and shipped on the fulfillment console's order page, and its reference is a saga
 * step id nobody reads, so it shows the order id instead. A boxed bag's reference is boxed's
 * `pk`, and it is still packed in Retool.
 */
export function OrderReference({
  row,
}: {
  row: { orderId: string; type: string; tenantReferenceId: string | null };
}) {
  if (row.type === "WITHDRAW_ASSET") {
    return (
      <Link
        className="font-mono text-xs underline-offset-2 hover:underline"
        to="/fulfillment/orders/$orderId"
        params={{ orderId: row.orderId }}
      >
        {row.orderId.slice(0, 8)}
      </Link>
    );
  }
  return <span className="font-mono text-xs">{dashIfEmpty(row.tenantReferenceId)}</span>;
}
